import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const DashboardHeader = () => {
  const { user } = useAuth();

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Mes estimations</h1>
      <p className="mt-1 text-sm text-gray-500">{user?.email}</p>
    </div>
  );
};

export default DashboardHeader;